<template>
  <!-- Content Left Rail -->
  <v-sheet class="settings-left-nav">
    <v-list-item-title class="settings-nav-title font-weight-medium"
      >Tracking</v-list-item-title
    >
    <v-list dense nav>
      <v-list-item
        class="subtitle-1"
        :class="routeColor('telecom-trck')"
        @click="navigateTo('telecom-trck')"
        v-if="$root.$children[0].isAdmin"
      >
        Tracking Numbers
      </v-list-item>
    </v-list>
  </v-sheet>
</template>

<script>
export default {
  name: "TrackingLeftNavigation",
  props: {
    msg: String
  },
  data: function() {
    return {
      toggleFilter: 1,
      selectedItem: null
    };
  },
  created() {},
  watch: {},
  computed: {},
  methods: {
    navigateTo(settingType) {
      this.$parent.$parent.$parent.settingsNavSelected = settingType;
    },
    routeColor(routeName) {
      return this.$parent.$parent.$parent.settingsNavSelected == routeName
        ? "font-weight-medium"
        : "font-weight-normal";
    }
  }
};
</script>

<style scoped lang="stylus">
.settings-left-nav {
  padding-top: 1rem;
}
div.settings-left-nav, div.settings-left-nav div {
  background-color: rgb(241, 241, 241);
  width: 100%;
}
.settings-left-nav div.v-list {
  padding: 0;
}
.settings-nav-title {
  padding: 1.5rem 2rem 0.5rem;
  font-size: 1.1rem;
  font-weight: 500;
  text-transform: uppercase;
}
.subtitle-1 {
  font-size: 1rem;
  font-weight: 400;
}
.v-list-item {
  padding: .5rem 2rem;
}
</style>
